var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.18 3.27C24.89 2.16 24.01 1.28 22.9 0.98C20.9 0.44 13 0.44 13 0.44C13 0.44 5.1 0.44 3.1 0.98C1.99 1.28 1.11 2.16 0.82 3.27C0.28 5.29 0.28 9.5 0.28 9.5C0.28 9.5 0.28 13.71 0.82 15.73C1.11 16.84 1.99 17.72 3.1 18.02C5.1 18.57 13 18.57 13 18.57C13 18.57 20.9 18.57 22.9 18.02C24.01 17.72 24.89 16.84 25.18 15.73C25.72 13.71 25.72 9.5 25.72 9.5C25.72 9.5 25.72 5.29 25.18 3.27ZM10.36 13.33V5.67L17.09 9.5L10.36 13.33Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.cc6179de2386e56c98e7b42d64396298.svg";
export { ForwardRef as ReactComponent };